import Immutable from 'immutable';
/* @ts-expect-error module is untyped */

import { cleanObject } from 'ecosystem-marketplace-core/utils/formatters';
/* @ts-expect-error module is untyped */

import ReviewSummary from 'ecosystem-marketplace-core/records/ReviewSummary';
const defaults = {
  companyName: '',
  exampleUrl: '',
  featureHeadlines: Immutable.List(),
  installsCount: 0,
  name: '',
  offeringId: 0,
  priceCents: 0,
  reviewSummary: null,
  slug: '',
  thumbnailUrl: ''
};

class ThemeCardResult extends Immutable.Record(defaults) {
  constructor(json = {}) {
    const jsonCopy = Object.assign({}, json);

    if (json.featureHeadlines) {
      jsonCopy.featureHeadlines = Immutable.List(json.featureHeadlines);
    }

    if (json.reviewSummary) {
      jsonCopy.reviewSummary = new ReviewSummary(json.reviewSummary);
    }

    super(cleanObject(jsonCopy));
  }

}

export default ThemeCardResult;